import classNames from '@/utils/classNames';
import type { FCC } from 'react-fc';
import styles from './ModalForm.module.css';

export const ModalForm: FCC = ({ className, children }) => (
    <div className={classNames(styles.modalForm, className)}>{children}</div>
);
